import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Dropdown, MenuProps } from 'antd';
import { CloseOutlined, MenuOutlined } from '@ant-design/icons';
import { getParenIdOfChildren } from '../../Pages/pagesBooks/childrenOfParents';
import { MenuType, makeMenuItems } from '../MenuMain';
import { useMobileMenuItems } from '../MenuMain/useMobileMenuItems';
import cx from 'classnames';
import { AppSystem } from '../../interfaces';
import {
    usePagesStoreCurrentComponent,
    usePagesStoreMenu,
    useProfile,
    useRouterStore,
    useUiDarkTheme,
    useUiLanguage,
} from '../../hooks';
import { authLogOutUser, setAppSystemBySwitch, setUiDarkTheme } from '../../middleware';
import Styles from './m_styles.less';

const goToComponentKey = (key: string): void => {
    console.log(new Date().toISOString(), '-(goToComponentKey)->', key, `<-key-`);
    if (typeof key !== 'undefined') {
        switch (key) {
            case AppSystem.OCS:
            case AppSystem.BILLING:
                setAppSystemBySwitch(key);
                break;
            case 'lightTheme':
                setUiDarkTheme(false);
                break;
            case 'darkTheme':
                setUiDarkTheme(true);
                break;
            case 'logOut':
                authLogOutUser().then();
                break;
            default:
                break;
        }
    }
};

export const MenuMobile: React.FC = observer(() => {
    const [isVisible, setVisible] = useState(false);
    const languageId = useUiLanguage();
    const isDark = useUiDarkTheme();
    const menu = usePagesStoreMenu();
    const { firstName, lastName } = useProfile();
    const routerStore = useRouterStore();
    const { routeName } = usePagesStoreCurrentComponent();
    const parentComponentId = getParenIdOfChildren(routeName);
    const selectKeys = parentComponentId ? [parentComponentId] : [];
    const mobileMenuItems: MenuProps['items'] = useMobileMenuItems() || [];
    const mainMenuItems: MenuProps['items'] = makeMenuItems({
        menu: menu,
        profileLabel: `${firstName} ${lastName}`,
        type: MenuType.MOBILE,
        routerStore,
        selectKeys,
    });

    const onVisibleChange = (): void => {
        setVisible(!isVisible);
    };

    const handleMobileMenuClick: MenuProps['onClick'] = (e) => {
        goToComponentKey(e.key);
        setVisible(!isVisible);
    };

    return (
        <Dropdown
            onOpenChange={onVisibleChange}
            menu={{
                items: [...mobileMenuItems, ...(mainMenuItems || [])],
                onClick: handleMobileMenuClick,
            }}
            trigger={['click']}
            open={isVisible}
        >
            <div className={Styles.iconPlace}>
                <CloseOutlined
                    className={cx(Styles.menuIcon, {
                        [Styles.showIcon]: isVisible,
                        [Styles.hideIcon]: !isVisible,
                        [Styles.dark]: isDark,
                        [Styles.light]: !isDark,
                    })}
                />
                <MenuOutlined
                    className={cx(Styles.menuIcon, {
                        [Styles.hideIcon]: isVisible,
                        [Styles.showIcon]: !isVisible,
                        [Styles.dark]: isDark,
                        [Styles.light]: !isDark,
                    })}
                />
            </div>
        </Dropdown>
    );
});
